import { UnidadeSelecaoOpcaoDTO } from "types/dto/unidade/UnidadeSelectDTO";

/**
 * Precisa ficar idêntico a UnidadeSelecaoOpcaoFactory.normalizarParaBusca (backend) e ao
 * normalizarTermoBusca do modal do V1: o termoBusca chega normalizado desse jeito.
 */
export const normalizarTermoBusca = (texto: unknown) =>
  String(texto ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s]|_/g, "")
    .toLowerCase()
    .trim();

/**
 * O termo normalizado nunca contém "|", então `includes` no termoBusca equivale a casar por
 * campo (nunca atravessa a fronteira entre dois campos).
 */
export const filtrarOpcaoUnidade = (option: { data: UnidadeSelecaoOpcaoDTO }, input: string) => {
  const termo = normalizarTermoBusca(input);
  if (!termo) {
    return true;
  }
  return (option.data?.termoBusca ?? "").includes(termo);
};
